// extracted by mini-css-extract-plugin
module.exports = {"emptyCarousel":"SearchEmptyCarousel_emptyCarousel___kgav","slideContent":"SearchEmptyCarousel_slideContent__MdMs3","dots":"SearchEmptyCarousel_dots__iOJPa"};